import { render, staticRenderFns } from "./contact-info.vue?vue&type=template&id=1aa3537c&scoped=true"
import script from "./contact-info.vue?vue&type=script&lang=ts"
export * from "./contact-info.vue?vue&type=script&lang=ts"
import style0 from "./contact-info.vue?vue&type=style&index=0&id=1aa3537c&prod&lang=scss&scoped=true"
import style1 from "./contact-info.vue?vue&type=style&index=1&id=1aa3537c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa3537c",
  null
  
)

export default component.exports